<template>
  <b-row class="right-sidebar">
    <b-col cols="12" md="4" lg="12" v-for="(item, index) in infoBar" :key="`bar-${index}`">
      <b-card
        no-body
        class="bg-white border mb-3 right-sidebar--item"
        :class="{ 'right-sidebar--featured': index === 0, 'right-sidebar--list': item.hasList }"
      >
        <div v-if="item.picture" class="card-img-top bg-aba-primary h-100">
          <b-img-lazy :src="`${SERVER_URL}${item.picture}`" alt="" class="img img-fluid w-100" />
        </div>
        <b-card-body class="p-3">
          <b-card-title
            title-tag="h2"
            :class="index === 0 ? 'amseu-title-featured m-0 mb-3' : 'amseu-title m-0 mb-4'"
            v-html="item.label"
          />
          <b-card-text class="fs-6" v-html="item.info_text" @click="handleContentClick" />
        </b-card-body>
        <b-card-footer v-if="item.showButton" class="p-3 pt-0 bg-white border-0">
          <b-button variant="primary" size="sm" class="w-100 custom-btn" @click="handleRegisterModal(index)">
            {{ translations[13782] }}
          </b-button>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { SERVER_URL } from '@/config/constant';
import { routeInternalContentLink } from '@/helpers/contentLinks';

const INDEXES_FOR_AUTH_MODAL = [0];

interface iBar {
  id: number
  info_text: string
  label: string
  picture: null | string
  showButton?: boolean
  hasList?: boolean
}

@Component
export default class RightSidebar extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get infoBar(): iBar[] {
    return AppModule.settingPortal.info_bars.map((el: any, index: number) => {
      const hasList = typeof el.info_text === 'string' && el.info_text.includes('<ul');
      return { ...el, showButton: index === 0, hasList };
    });
  }

  get sid() {
    return AppModule.sid;
  }

  SERVER_URL = SERVER_URL;

  handleContentClick(event: MouseEvent) {
    routeInternalContentLink(event, this.$router);
  }

  handleRegisterModal(index: number) {
    if (INDEXES_FOR_AUTH_MODAL.includes(index)) {
      this.$bvModal.show('register-modal');
    }
  }
}
</script>
<style scoped lang="scss">
.amseu-title {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #0054A6;
}

.amseu-title-featured {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.3;
  color: #333333 !important;
}

.right-sidebar--item {
  border-radius: 12px;
  overflow: hidden;
  transition: border-color .2s ease-in-out, box-shadow .2s ease-in-out;

  &:not(.right-sidebar--featured):hover {
    border-color: var(--aba-primary) !important;
    box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .08);
  }
}

// Перший блок: без наведення, постійна тінь
.right-sidebar--featured {
  box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .08);
}

// Блок зі списком (ul/li) — навігація з шевронами та роздільниками
.right-sidebar--list {
  ::v-deep .card-text {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      position: relative;

      & + li {
        border-top: 1px solid #e9ecef;
      }

      a {
        display: block;
        padding: 12px 8px 12px 28px;
        color: #212529;
        font-size: 14px;
        line-height: 1.4;
        text-decoration: none;
        transition: color .2s ease-in-out;

        &::before {
          content: '';
          position: absolute;
          left: 6px;
          top: 50%;
          width: 7px;
          height: 7px;
          border-top: 2px solid #0054A6;
          border-right: 2px solid #0054A6;
          transform: translateY(-50%) rotate(45deg);
        }

        &:hover {
          color: #0054A6;
        }
      }
    }
  }
}
</style>
